export const FETCH_STATIC_PAGE_REQUEST = 'STATIC_PAGE/FETCH_STATIC_PAGE_REQUEST';
export const FETCH_STATIC_PAGE_FAILURE = 'STATIC_PAGE/FETCH_STATIC_PAGE_FAILURE';
export const FETCH_STATIC_PAGE_SUCCESS = 'STATIC_PAGE/FETCH_STATIC_PAGE_SUCCESS';
